import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { firebase } from './../tools/tools';

@Injectable()
export class AuthGuardService implements CanActivate{

  constructor( private router:Router ) { }

  canActivate(){
    return this.isAuthenticated().then( user =>{
        return true;
      })
      .catch(err =>{
        this.router.navigate(['authentication/login'])
        return false
      });

  }

  isAuthenticated(){
    return new Promise<any>(function (resolve, reject) {

      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          resolve(user);
        } else {
          reject(Error('It broke'));
        }
      });

    });
  }

}
